import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QUALIFIED_CHATBOT_SCRIPT_SRC } from "constants/qualified-chatbot";
const QualifiedChatbotScript = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("script", {
                dangerouslySetInnerHTML: {
                    __html: `(function(w,q){w['QualifiedObject']=q;w[q]=w[q]||function(){(w[q].q=w[q].q||[]).push(arguments)};})(window,'qualified')`
                }
            }),
            /*#__PURE__*/ _jsx("script", {
                async: true,
                src: QUALIFIED_CHATBOT_SCRIPT_SRC
            })
        ]
    });
export default QualifiedChatbotScript;
